

















































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AntecipacaoRecebiveisStore from '../RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'

@Component({ name: 'AntecipacaoCarteira' })
export default class AntecipacaoCarteira extends Vue {
  @Prop({ default: false }) value: boolean

  mostrarFaq: boolean = false

  faqItems: { pergunta: string, resposta: string }[] = [
    {
      pergunta: 'O que é Antecipação de Honorários Fin-X?',
      resposta: 'É uma forma de receber antes da data habitual os valores que você tem a receber pelos '
        + 'serviços prestados. Assim, você consegue ter liquidez imediata sem precisar esperar o prazo '
        + 'normal de repasse.',
    },
    {
      pergunta: 'Como faço para antecipar e quais são os critérios avaliados?',
      resposta: 'Você acessa a plataforma Fin-X, simula o valor que deseja antecipar, envia a solicitação e '
        + 'autoriza o contato telefônico para formalização, antes da liberação do valor em conta corrente (PJ). '
        + 'Usamos informações que já temos sobre seu histórico de recebimentos e sua média de honorários para '
        + 'determinar o limite disponível.',
    },
    {
      pergunta: 'Quando receberei o dinheiro?',
      resposta: 'Após a solicitação ser aprovada e o contrato ser assinado digitalmente com certificado '
        + 'ICP-Brasil, o valor será transferido automaticamente para sua conta (PJ) via Pix programado, no '
        + 'mesmo dia ou conforme agendamento acordado. Será gerado e enviado automaticamente um boleto com o '
        + 'valor a ser pago na data acordada.',
    },
    {
      pergunta: 'Meus repasses de honorários junto ao hospital mudam com a antecipação?',
      resposta: 'Não. O fluxo normal de pagamento de honorários do hospital para você não sofre nenhuma '
        + 'alteração. A antecipação de honorários é apenas um adiantamento do valor que você já teria a '
        + 'receber, sem interferir na relação financeira entre você e o hospital.',
    },
    {
      pergunta: 'Qual é a segurança da operação?',
      resposta: 'Todo o processo é feito na Plataforma Digital Fin-X, contratos eletrônicos e arcabouço '
        + 'regulatório. A operação é legal e transparente, e você só antecipa valores que já tem a receber.',
    },
  ]

  get getAntecipacaoStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get instituicoes(): any[] {
    return this.getAntecipacaoStore.antecipacaoProfissional || []
  }

  onVerHistorico() {
    this.$emit('abrir-historico')
  }
}
